/**
 * @public
 */ export var AdInsertionType = /*#__PURE__*/ function(AdInsertionType) {
    AdInsertionType["MultiPlayerCsai"] = "MultiPlayerCsai";
    AdInsertionType["Yospace"] = "Yospace";
    AdInsertionType["MediaTailor"] = "MediaTailor";
    AdInsertionType["NativeCsai"] = "NativeCsai";
    AdInsertionType["None"] = "None";
    return AdInsertionType;
}({});

//# sourceMappingURL=ad-insertion-type.js.map